module.exports = __webpack_public_path__ + "img/thumb-blank.d910739b.svg";